export const handleGalleryDetails = (scroll) => {
  const details = document.querySelectorAll('.js-gallery-details');
  details.forEach(e => {
    // if mouse is on details, stop locomotive
    e.addEventListener('mouseenter', () => {
      scroll.stop();
    });
    // if mouse is out of details, start locomotive
    e.addEventListener('mouseleave', () => {
      scroll.start();
    });
  });
};
